export const BIG_DOG_LINE = ["Made with big dogs in mind. Good dogs of every size welcome.", "Pensé pour les grands chiens. Les bons chiens de toutes tailles sont les bienvenus."];

export const CHARACTERS = [
  {
    id: "worker",
    title: ["The one who works for a living", "Celui qui gagne sa vie"],
    line: ["Farm dogs. Shop dogs. Working dogs. Dogs who consider retirement a personal insult.", "Chiens de ferme. Chiens de boutique. Chiens de travail. Des chiens qui prennent la retraite comme une insulte personnelle."],
    picks: ["trailhead_vigor", "foresters_guard"],
    why: ["Cordyceps to support stamina through a long shift, with turkey tail as the daily base that helps maintain everyday wellness.", "Le cordyceps pour soutenir l'endurance pendant une longue journée, et la queue de dinde comme base quotidienne pour aider à maintenir le bien-être."],
  },
  {
    id: "adventurer",
    title: ["The adventure dog", "Le chien d'aventure"],
    line: ["Hunters. Hikers. Lake swimmers. Unrepentant mud collectors.", "Chasseurs. Randonneurs. Nageurs de lac. Collectionneurs de boue impénitents."],
    picks: ["trailhead_vigor", "foresters_guard"],
    why: ["Vigor supports energy and recovery after a big day out; the Guard helps maintain a well-defended dog between outings.", "La Vigueur soutient l'énergie et la récupération après une grosse sortie; la Garde aide à maintenir un chien bien protégé entre deux escapades."],
  },
  {
    id: "old_soul",
    title: ["The old soul", "La vieille âme"],
    line: ["A little slower getting up. Still absolutely coming with you.", "Un peu plus lent à se lever. Vient quand même absolument avec vous."],
    picks: ["grey_muzzle_reserve"],
    why: ["Lion's mane, set aside for the elders of the pack.", "La crinière de lion, réservée aux aînés de la meute."],
  },
  {
    id: "gentleman",
    title: ["The large gentleman", "Le grand gentleman"],
    line: ["More dog. More joints. More opinions about where he should be allowed to sit.", "Plus de chien. Plus d'articulations. Plus d'opinions sur l'endroit où il devrait avoir le droit de s'asseoir."],
    picks: ["grey_muzzle_reserve", "foresters_guard"],
    why: ["The Reserve supports mobility for a frame that carries a lot of dog; the Guard helps maintain the everyday foundation.", "La Réserve soutient la mobilité d'une charpente qui porte beaucoup de chien; la Garde aide à maintenir la base quotidienne."],
  },
  {
    id: "house_dog",
    title: ["The professional house dog", "Le chien de maison professionnel"],
    line: ["Walks around the block. Supervises dinner. Has never worked a day in his life.", "Fait le tour du pâté de maisons. Supervise le souper. N'a jamais travaillé un seul jour de sa vie."],
    picks: ["foresters_guard", "riverbend_calm"],
    why: ["The Guard as a quiet daily measure; Riverbend Calm for the watchful ones who like to supervise the doorbell too.", "La Garde comme mesure quotidienne tranquille; le Calme de la Rivière pour les vigilants qui surveillent aussi la sonnette."],
  },
];

export const NEEDS = [
  { id: "mobility", label: ["Mobility", "Mobilité"], picks: ["grey_muzzle_reserve", "trailhead_vigor"] },
  { id: "recovery", label: ["Recovery", "Récupération"], picks: ["trailhead_vigor"] },
  { id: "cognitive", label: ["Cognitive support", "Soutien cognitif"], picks: ["grey_muzzle_reserve"] },
  { id: "immune", label: ["Immune support", "Soutien immunitaire"], picks: ["foresters_guard"] },
  { id: "calm", label: ["Settling and calm", "Apaisement et calme"], picks: ["riverbend_calm"] },
  { id: "everyday", label: ["Everyday wellness", "Bien-être quotidien"], picks: ["foresters_guard", "discovery_dram"] },
];

export const MUSHROOMS = [
  { id: "turkey_tail", label: ["Turkey Tail", "Queue de dinde"], picks: ["foresters_guard", "discovery_dram"] },
  { id: "cordyceps", label: ["Cordyceps", "Cordyceps"], picks: ["trailhead_vigor", "discovery_dram"] },
  { id: "lions_mane", label: ["Lion's Mane", "Crinière de lion"], picks: ["grey_muzzle_reserve"] },
  { id: "reishi", label: ["Reishi", "Reishi"], picks: ["riverbend_calm", "discovery_dram"] },
];

export const DRAM_NUDGE = ["Not sure yet? Start with the Dram.", "Pas encore certain? Commencez par la Fiole."];

export function characterResult({ characters, ageYears, need }) {
  const score = {};
  const add = (id, n) => { if (id !== "discovery_dram") score[id] = (score[id] || 0) + n; };
  CHARACTERS.filter((c) => characters.includes(c.id)).forEach((c) => c.picks.forEach((id) => add(id, 3)));
  NEEDS.find((n) => n.id === need)?.picks.forEach((id, i) => add(id, i === 0 ? 3 : 1));
  if (Number(ageYears) >= 8) add("grey_muzzle_reserve", 2);
  const ranked = Object.entries(score).sort((a, b) => b[1] - a[1]);
  if (!ranked.length) return ["foresters_guard"];
  const [first, second] = ranked;
  return second && second[1] >= 3 ? [first[0], second[0]] : [first[0]];
}
